import { activity } from '@/locales/en-GB/activity';
import { assistant } from '@/locales/en-GB/assistant';
import { assets } from '@/locales/en-GB/assets';
import { auth } from '@/locales/en-GB/auth';
import { billing } from '@/locales/en-GB/billing';
import { common } from '@/locales/en-GB/common';
import { contacts } from '@/locales/en-GB/contacts';
import { copilot } from '@/locales/en-GB/copilot';
import { home } from '@/locales/en-GB/home';
import { inspections } from '@/locales/en-GB/inspections';
import { jobs } from '@/locales/en-GB/jobs';
import { lifecycleGate } from '@/locales/en-GB/lifecycleGate';
import { navigation } from '@/locales/en-GB/navigation';
import { profile } from '@/locales/en-GB/profile';
import { schedule } from '@/locales/en-GB/schedule';
import { sites } from '@/locales/en-GB/sites';
import { timeline } from '@/locales/en-GB/timeline';
import { work } from '@/locales/en-GB/work';
import { workspace } from '@/locales/en-GB/workspace';
import { enUSResources } from '@/locales/en-US';
import { mergeLocaleResources } from '@/locales/mergeLocaleResources';

export const enGBResources = mergeLocaleResources(enUSResources, {
  common,
  auth,
  navigation,
  profile,
  workspace,
  billing,
  work,
  assets,
  inspections,
  jobs,
  lifecycleGate,
  contacts,
  copilot,
  home,
  assistant,
  activity,
  schedule,
  sites,
  timeline,
} as const);

export type EnGBResources = typeof enGBResources;
